__webpack_require__.p = "/reports-dashboard-templates-empty-dashboards-list/account-setup/";